module.exports = __webpack_public_path__ + "img/darwinkopf.beb52b44.jpg";